module.exports = __webpack_public_path__ + "img/icon-inativo.dc8a2982.png";